module.exports = __webpack_public_path__ + "static/kababayan-b9bfaf104f075fb99906c7c82fdfcf9f.jpg";